import BalanceDetail from './BalanceDetail';

export {BalanceDetail};
